import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ImageUrl } from 'src/constants/imagesConst';
import { API_BASE_URL } from 'src/apiConfig';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';

/* RESETOVANJE LOZINKE FORMA */
const ResetPasswordForm = () => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isLoading, setIsLoading] = useState(false); // Dodato za loading
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleResetPassword = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      setError(t('resetPassword.passwordMismatch'));
      return;
    }

    try {
      setIsLoading(true); // Početak loadinga
      const token = searchParams.get('token');

      const response = await axios.post(`${API_BASE_URL}/api/auth.php`, {
        action: 'resetPassword',
        token: token,
        newPassword: newPassword
      });

      if (response.data.success) {
        setSuccess(t('resetPassword.successMessage'));
        setTimeout(() => {
          setIsLoading(false); // Kraj loadinga pre navigacije
          navigate('/');
        }, 3000);
      } else {
        setError(response.data.error || t('resetPassword.generalError'));
        setIsLoading(false); // Kraj loadinga u slučaju greške
      }
    } catch (error) {
      setError(t('resetPassword.generalError'));
      setIsLoading(false); // Kraj loadinga u slučaju greške
      console.error('Greška prilikom resetovanja lozinke:', error.message);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: 'linear-gradient(135deg, #2596be 0%, #c2e9fb 100%)'
      }}
    >
      <Backdrop
        open={isLoading}
        style={{ zIndex: 1000, color: '#fff' }} // Stil za pozadinu i poziciju loadera
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <div
        style={{
          background: '#fff',
          padding: '40px',
          borderRadius: '20px',
          boxShadow: '0px 6px 20px rgba(0, 0, 0, 0.15)',
          width: '400px',
          textAlign: 'center',
          position: 'relative'
        }}
      >
        <img
          src="/kengur2/assets/kengur.png"
          alt="Kengur"
          style={{
            width: '80px',
            height: '80px',
            marginBottom: '20px',
            position: 'absolute',
            top: '-40px',
            left: 'calc(50% - 40px)'
          }}
        />
        <h2 style={{ color: '#2596be', fontWeight: 'bold' }}>
          {t('general.kengurFull')}
        </h2>
        {error && <p style={{ color: 'red' }}>{error}</p>}
        {success && <p style={{ color: 'green' }}>{success}</p>}

        <form onSubmit={handleResetPassword}>
          <div style={{ marginBottom: '20px' }}>
            <input
              type="password"
              placeholder={t('resetPassword.newPass')}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '12px',
                borderRadius: '8px',
                border: '1px solid #ddd',
                marginBottom: '10px'
              }}
              disabled={isLoading} // Onemogućiti unos tokom loadinga
            />
          </div>
          <div style={{ marginBottom: '20px' }}>
            <input
              type="password"
              placeholder={t('resetPassword.confirm')}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '12px',
                borderRadius: '8px',
                border: '1px solid #ddd',
                marginBottom: '10px'
              }}
              disabled={isLoading} // Onemogućiti unos tokom loadinga
            />
          </div>
          <button
            type="submit"
            style={{
              background: isLoading ? '#ccc' : '#2596be',
              color: 'white',
              padding: '12px',
              border: 'none',
              borderRadius: '8px',
              width: '100%',
              cursor: isLoading ? 'not-allowed' : 'pointer',
              fontSize: '16px',
              fontWeight: 'bold'
            }}
            disabled={isLoading} // Onemogućiti dugme tokom loadinga
          >
            {t('resetPassword.resetButton')}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPasswordForm;
